export function isSuperset<T>(set: Set<T>, subset: Iterable<T>): boolean {
	for (const elem of subset) {
		if (!set.has(elem)) {
			return false;
		}
	}
	return true;
}

export function areEqual<T>(setA: Set<T>, setB: Set<T>): boolean {
	if (setA.size !== setB.size) {
		return false;
	}

	for (const elem of setB) {
		if (!setA.has(elem)) {
			return false;
		}
	}

	return true;
}

export function union<T>(setA: Set<T>, ...otherSets: Iterable<T>[]): Set<T> {
	const setC: Set<T> = new Set(setA);
	for (const setB of otherSets) {
		for (const elem of setB) {
			setC.add(elem);
		}
	}
	return setC;
}

export function union2<T>(iterables: Iterable<T>[]): Set<T> {
	const set: Set<T> = new Set();
	for (const iterable of iterables) {
		for (const item of iterable) {
			set.add(item);
		}
	}
	return set;
}

export function intersection<T>(setA: Set<T>, setB: Iterable<T> | undefined): Set<T> {
	const setC: Set<T> = new Set();

	if (setB) {
		for (const elem of setB) {
			if (setA.has(elem)) {
				setC.add(elem);
			}
		}
	}

	return setC;
}

export function countIntersection<T>(setA: Set<T>, setB: Iterable<T> | undefined): number {
	let c = 0;

	if (setB) {
		for (const elem of setB) {
			if (setA.has(elem)) {
				++c;
			}
		}
	}

	return c;
}

export function doesIntersect<T>(setA: Set<T>, setB: Iterable<T>): boolean {
	for (const elem of setB) {
		if (!setA.has(elem)) {
			return true;
		}
	}
	return false;
}

export function difference<T>(setA: Set<T>, setB: Iterable<T>): Set<T> {
	const setC: Set<T> = new Set(setA);
	for (const elem of setB) {
		setC.delete(elem);
	}
	return setC;
}

export function doUnion<T>(a: Set<T>, b: Iterable<T>): void {
	for (const item of b) {
		a.add(item);
	}
}

export function doDifference<T>(a: Set<T>, b: Iterable<T>): void {
	for (const item of b) {
		a.delete(item);
	}
}

export function doDifference2<T>(a: Set<T>, b: Set<T>): void {
	if (a.size < b.size) {
		for (const item of a) {
			if (b.has(item)) {
				a.delete(item);
			}
		}
	} else {
		for (const item of b) {
			a.delete(item);
		}
	}
}
